import { Observable } from 'rxjs/Observable';
import { Injectable } from '@angular/core';
import { Subject } from 'rxjs/Subject';
@Injectable()
export class SharedService {
    // Observable string sources
    private emitChangeSource = new Subject<any>();
    private emitChangeDialog = new Subject<any>();
    private emitChangeOverlay = new Subject<any>();
    private yesAction = new Subject<any>();
    private noAction = new Subject<any>();
    private bookingAction = new Subject<any>();
    private profileeditAction = new Subject<any>();  
    private diagnosisAction = new Subject<any>();
    private paidTransactionAction = new Subject<any>();
    // Observable string streams
    changeEmitted$ = this.emitChangeSource.asObservable();
    // Observable string streams
    dialogEmitted$ = this.emitChangeDialog.asObservable();

    overlayEmitted$ = this.emitChangeOverlay.asObservable();
    // Observable string streams
    yesEmitted$ = this.yesAction.asObservable();
    // Observable string streams
    noEmitted$ = this.noAction.asObservable();
    bookingEmitted$ = this.bookingAction.asObservable();
    profileeditEmitted$ = this.profileeditAction.asObservable();
    diagnosisAction$ = this.diagnosisAction.asObservable();
    paidTransactionAction$ = this.paidTransactionAction.asObservable();
    // Service message commands
    emitChange(change: any) {
        this.emitChangeSource.next(change);
    }

    // Service message commands
    overlay(change: any) {
        this.emitChangeOverlay.next(change);
    }
    // Service message commands
    emitDialog(change: boolean, header : string, message : string, isPrompt : boolean, type : string, page : string, data ?: any ) {
        this.emitChangeDialog.next({change : change , header :header ,message :message,isPrompt :isPrompt, type : type, page : page, data : data } );
    }
    reactiveemitDialog(change: boolean, header : string, message : string, isPrompt : boolean, type : string, page : string, data ?: any ) {
        this.emitChangeDialog.next({change : change , header :header ,message :message,isPrompt :isPrompt, type : type, page : page, data : data } );
    }
    // Service message commands
    yes(change: any) {
        this.yesAction.next(change);
    }
    // Service message commands
    no(change: any) {
        this.yesAction.next(change);
    }
    booking(change: any) {
        this.bookingAction.next(change);
    }
    profileedit(change: any) {
        this.profileeditAction.next(change);
    }
    updatePrescription(change: any) {
        this.diagnosisAction.next(change);
    }
    setTransactionAction(change: any) {
        this.paidTransactionAction.next(change);
    }
}


// WEBPACK FOOTER //
// ./src/app/component/shared/shared.service.ts